import React, { useContext, useEffect, useState } from "react";
import { CommonModal, H6 } from "../../../AbstractElements";
import { Row, Col, Form, FormGroup, Label, Input, InputGroup, Table } from "reactstrap";
import Select from "react-select";
import { useForm, useController } from "react-hook-form";
import { getCarTypes, getCabs, showAlert, getUserDetails } from "../../../Services/Shared.service";
import { checkRoleAddition, createDriverAdhoc, driverDocumentUpload, getAggregators, getDriverDocuments, updateDriverAdhoc } from "../../../Services/DispatchDashboard.service";
import DatePicker from "react-datepicker";
import { ArrowDown, ArrowUp, PlusSquare, Trash2 } from "react-feather";
import CustomAutoSuggest from "../../../CommonElements/CustomAutoSuggest";
import { getDriverTypes } from "../../../Services/Driver.service";
import { getDriverDetails } from "../../../Services/Booking.service";
import CustomSelect from "../../../CommonElements/CustomSelect";
import CustomizerContext from "../../../_helper/Customizer";
import { getParentCompany } from "../../../Services/Ventor.service";

const CreateDriver = ({
    Large,
    title,
    LargeModaltoggle,
    cityDataList,
    setShowApiLoader,
    editId
}) => {
    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        reset,
        trigger,
        clearErrors,
        getValues
    } = useForm({
        defaultValues: {
            sapId: "",
            isSapData: false,
            fullName: "",
            gender: "",
            dob: "",
            mobile: "",
            addressLine: "",
            city: "",
            pincode: "",
            state: "",
            education: "",
            experience: "",
            langKnown: "",
            licenseNo: "",
            badge: "",
            bangDriverId: "",
            remarks: "",
            fathersName: "",
            phone1: "",
            phone2: "",
            licenseExpiry: "",
            mainCabNoTypeDropdown: "",
            driverRatingDropdown: "",
            aggregatorDropdown: "",
            serviceCity: "",
            panCardNo: "",
            aadharNo: "",
            driverTypeDropdown: "",
            isAvailable: true,
            badgeExpiry: "",
            displayCardNo: "",
            displayCardNoExpiry: "",
            policeVerificationCode: "",
            vendor: "",
            policeVerificationExpiry: "",
            setAsPrimaryDriver: true,
            setAsSecondaryDriver: false,
            isEvDriver: false
        }
    });
    const {mix_background_layout} = useContext(CustomizerContext)

    console.log("values", getValues())

    const genderData = [
        { label: "Male", value: "M", },
        { label: "Female", value: "F" },
        {label : "Transgender", value :"T"}
    ]
    const aggregatorField = useController({
        name: "aggregatorDropdown",
        control,
        rules: {
            required: {
                value: true,
                message: "Aggregator is Required",
            },
        },
    }).field;

    const [carTypeData, setCarTypeData] = useState([]);
    const [driverTypeList, setDriverTypeList] = useState([]);
    const [aggregatorList, setAggregatorList] = useState([]);
    const [cabData, setCabData] = useState([]);
    const [isAdvanced, setIsAdvanced] = useState(false);
    const [tabName, setTabName] = useState("Driver Information")
    const [files, setFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [confirmationModal, setConfirmationModal] = useState(false)
    const [driverDetails, setDriverDetails] = useState({})

    useEffect(() => {
        getParentCompany().then((result) => {
            if (result.data) {
                const data = result.data.filter((element) => element.isDeleted === false).map((element) => {
                    return {
                        label: element.companyName,
                        value: element,
                    };
                });
                setAggregatorList(data);
            }
        });
        getDriverTypes().then((result) => {
            if (result.data) {
                const data = result.data.map((element) => {
                    return {
                        label: element.name,
                        value: element,
                    };
                });
                setDriverTypeList(data);
            }
        });
    }, []);

    useEffect(() => {
        console.log("inside useeffect edit id", editId)
        if (editId) {
            getParentCompany().then((result) => {
                if (result.data) {
                    const data = result.data.filter((element) => element.isDeleted === false).map((element) => {
                        return {
                            label: element.companyName,
                            value: element,
                        };
                    });
                    setAggregatorList(data);
                }
            });
            getDriverTypes().then((result) => {
                if (result.data) {
                    const data = result.data.map((element) => {
                        return {
                            label: element.name,
                            value: element,
                        };
                    });
                    setDriverTypeList(data);
                }
            });
            getDriverDetails(editId)
                .then((result) => {
                    if (result.data) {
                        setDriverDetails(result.data)
                        reset({
                            sapId: result.data?.sapId ? result.data.sapId : "",
                            isSapData: result.data?.isSapData ? true : false,
                            fullName: result.data?.fullName ? result.data.fullName : "",
                            gender: result.data?.gender ? result.data.gender : "",
                            dob: result.data?.dob ? new Date(result.data.dob) : "",
                            mobile: result.data?.mobile ? result.data.mobile : "",
                            addressLine: result.data?.addressLine ? result.data.addressLine : "",
                            city: result.data?.city ? result.data.city : "",
                            pincode: result.data?.pincode ? result.data.pincode : "",
                            state: result.data?.state ? result.data.state : "",
                            education: result.data?.education ? result.data.education : "",
                            experience: result.data?.experience ? result.data.experience : "",
                            langKnown: result.data?.langKnown ? result.data.langKnown : "",
                            licenseNo: result.data?.licenseNo ? result.data.licenseNo : "",
                            badge: result.data?.badge ? result.data.badge : "",
                            bangDriverId: result.data?.bangDriverId ? result.data.bangDriverId : "",
                            remarks: result.data?.remarks ? result.data.remarks : "",
                            fathersName: result.data?.fathersName ? result.data.fathersName : "",
                            phone1: result.data?.phone1 ? result.data.phone1 : "",
                            phone2: result.data?.phone2 ? result.data.phone2 : "",
                            licenseExpiry: result.data?.licenseExpiry ? new Date(result.data.licenseExpiry) : "",
                            mainCabNoTypeDropdown: result.data?.mainCabNo ? { carNo: result.data.mainCabNo } : "",
                            mainCabNo: result.data?.mainCabNo ? result.data.mainCabNo : "",
                            driverRatingDropdown: result.data?.megacabsRating ? result.data.megacabsRating.toString() : "",
                            aggregatorDropdown: result.data?.aggregatorId ? { id: result.data.aggregatorId } : "",
                            serviceCity: result.data?.serviceCityId ? { id: result.data.serviceCityId } : "",
                            panCardNo: result.data?.panCardNo ? result.data.panCardNo : "",
                            aadharNo: result.data?.aadharNo ? result.data.aadharNo : "",
                            driverTypeDropdown: result.data?.driverTypeId ? { id: result.data.driverTypeId } : "",
                            isAvailable: result.data?.isAvailable ? true : false,
                            badgeExpiry: result.data?.badgeExpiry ? new Date(result.data.badgeExpiry) : "",
                            displayCardNo: result.data?.displayCardNo ? result.data.displayCardNo : "",
                            displayCardNoExpiry: result.data?.displayCardNoExpiry ? new Date(result.data.displayCardNoExpiry) : "",
                            policeVerificationCode: result.data?.policeVerificationCode ? result.data.policeVerificationCode : "",
                            vendor: result.data?.vendor ? result.data.vendor : "",
                            policeVerificationExpiry: result.data?.policeVerificationExpiry ? new Date(result.data.policeVerificationExpiry) : "",
                            setAsPrimaryDriver: result.data?.isPrimary ? true : false,
                            setAsSecondaryDriver: false,
                            isEvDriver: result.data?.isEvDriver ? true : false
                        })
                        getDriverDocuments(editId).then((result) => {
                            setUploadedFiles(result.data)
                        }).catch((err) => {
                            showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
                        });
                    }
                })
                .catch((err) => {
                    showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
                });
        }
    }, [editId])

    const ratingData = [
        { label: "0", value: "0" },
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "3.5", value: "3.5" },
        { label: "4", value: "4" },
        { label: "4.5", value: "4.5" },
        { label: "5", value: "5" }
    ]

    const serviceCityField = useController({
        name: "serviceCity",
        control,
        rules: {
            required: {
                value: true,
                message: "Service City is Required",
            },
        },
    }).field;

    const genderField = useController({
        name: "gender",
        control,
        rules: {
            required: {
                value: true,
                message: "Gender is Required",
            },
        },
    }).field;

    const DOBField = useController({
        name: "dob",
        control,
        rules: {
            required: {
                value: true,
                message: "Date of birth is Required",
            },
        },
    }).field;

    const DrivingLicenseExpiryField = useController({
        name: "licenseExpiry",
        control,
        rules: {},
    }).field;

    const badgeExpiryField = useController({
        name: "badgeExpiry",
        control,
        rules: {},
    }).field;

    const displayCardNoExpiryField = useController({
        name: "displayCardNoExpiry",
        control,
        rules: {},
    }).field;

    const policeVerificationExpiryField = useController({
        name: "policeVerificationExpiry",
        control,
        rules: {},
    }).field;


    const isSapDataField = useController({
        name: "isSapData",
        control,
        rules: {},
    }).field;

    const isAvailableField = useController({
        name: "isAvailable",
        control,
        rules: {},
    }).field;

    const isEVDriverField = useController({
        name: "isEvDriver",
        control,
        rules: {},
    }).field;

    const isPrimaryDriverField = useController({
        name: "setAsPrimaryDriver",
        control,
        rules: {},
    }).field;


    // const carTypeField = useController({
    //     name: "carTypeDropdown",
    //     control,
    //     rules: {
    //         required: {
    //             value: true,
    //             message: "Car type is Required",
    //         },
    //     },
    // }).field;

    const driverTypeField = useController({
        name: "driverTypeDropdown",
        control,
        rules: {
            required: {
                value: true,
                message: "Driver Type is Required",
            },
        },
    }).field;

    const mainCabNoField = useController({
        name: "mainCabNoTypeDropdown",
        control,
        rules: {},
    }).field;

    const driverRatingField = useController({
        name: "driverRatingDropdown",
        control,
        rules: {},
    }).field;

    const driverMobileField = useController({
        name: "mobile",
        control,
        rules: {
            required: {
                value: true,
                message: "Driver Mobile is Required",
            },
            minLength: {
                value: 10,
                message: "Driver Mobile cannot be less than 10",
            },
            maxLength: {
                value: 10,
                message: "Driver Mobile cannot be more than 10",
            },
            min: {
                value: 0,
                message: "Invalid Driver Mobile",
            },
            maxLength: 10
        },
    }).field;

    const driverAadhaarField = useController({
        name: "aadharNo",
        control,
        rules: {
          required: {
            value: true,
            message: "Aadhaar Number is Required",
          },
          minLength: {
            value: 12,
            message: "Aadhaar Number cannot be less than 12",
          },
          maxLength: {
            value: 12,
            message: "Aadhaar Number cannot be more than 12",
          },
          min: {
            value: 0,
            message: "Invalid Aadhaar Number",
          },
          maxLength: 12,
        },
      }).field;

    const phone1Field = useController({
        name: "phone1",
        control,
        rules: {
            maxLength: 10
        },
    }).field;

    const phone2Field = useController({
        name: "phone2",
        control,
        rules: {
            maxLength: 10
        },
    }).field;

    const cityData = cityDataList ? cityDataList : [];

    useEffect(() => {
        const serviceCityId = serviceCityField.value?.id;
        if (!serviceCityId) {
            setCarTypeData([]);
            return;
        }
        let obj = {
            serviceCityId,
        };
        getCarTypes(obj)
            .then((result) => {
                const data = result.data.map((element) => {
                    return {
                        label: element.name,
                        value: element,
                    };
                });
                setCarTypeData(data);
            })
            .catch((err) => {
                showAlert("error", "Unable to fetch Car details for selected City");
            });

        getCabs(obj)
            .then((result) => {
                setCabData(result.data);
            })
            .catch((err) => {
                showAlert("error", "Unable to fetch Car details for selected City");
            });
    }, [serviceCityField.value]);

    const createDriver = () => {
        const values = getValues();
        const body = {
            userId: null,
            sapId: values.sapId ? values.sapId : null,
            isSapData: values.isSapData ? values.isSapData : null,
            fullName: values.fullName ? values.fullName : null,
            gender: values.gender ? values.gender : null,
            dob: values.dob ? new Date(values.dob) : null,
            mobile: values.mobile ? values.mobile : null,
            addressLine: values.addressLine ? values.addressLine : null,
            city: values.city ? values.city : null,
            pincode: values.pincode ? values.pincode : null,
            state: values.state ? values.state : null,
            education: values.education ? values.education : null,
            experience: values.experience ? values.experience : null,
            langKnown: values.langKnown ? values.langKnown : null,
            licenseNo: values.licenseNo ? values.licenseNo : null,
            badge: values.badge ? values.badge : null,
            remarks: values.remarks ? values.remarks : null,
            fathersName: values.fathersName ? values.fathersName : null,
            phone1: values.phone1 ? values.phone1 : null,
            phone2: values.phone2 ? values.phone2 : null,
            avatarUrl: null,
            avatarUrlContentType: null,
            avatarUrlData: null,
            licenseExpiry: values.licenseExpiry ? new Date(values.licenseExpiry) : null,
            dailySubscriptionAmt: null,
            mainCabNo: values.mainCabNoTypeDropdown?.carNo ? values.mainCabNoTypeDropdown.carNo : null,
            otherCabNo: values.mainCabNoTypeDropdown?.carNo ? values.mainCabNoTypeDropdown.carNo : null,
            ratingSum: null,
            ratingCount: null,
            ratingAvg: null,
            createdOn: null,
            createdById: null,
            isDeleted: null,
            deletedOn: null,
            deletedById: null,
            aggregatorId: values.aggregatorDropdown?.id ? values.aggregatorDropdown.id : null,
            serviceCityId: values.serviceCity?.id ? values.serviceCity.id : null,
            panCardNo: values.panCardNo ? values.panCardNo : null,
            aadharNo: values.aadharNo ? values.aadharNo : null,
            driverTypeId: values.driverTypeDropdown?.id ? values.driverTypeDropdown.id : null,
            isAvailable: values.isAvailable ? true : false,
            badgeExpiry: values.badgeExpiry ? new Date(values.badgeExpiry) : null,
            displayCardNo: values.displayCardNo ? values.displayCardNo : null,
            displayCardNoExpiry: values.displayCardNoExpiry ? new Date(values.displayCardNoExpiry) : null,
            policeVerificationDate: null,
            vendor: values.vendor ? values.vendor : "",
            policeVerificationCode: values.policeVerificationCode ? values.policeVerificationCode : null,
            policeVerificationExpiry: values.policeVerificationExpiry ? new Date(values.policeVerificationExpiry) : null,
            megacabsRating: values.driverRatingDropdown ? values.driverRatingDropdown : null,
            bangDriverId: values.bangDriverId ? values.bangDriverId : null,
            isDriverAdhoc: false,
            setAsPrimaryDriver: values.setAsPrimaryDriver ? true : false,
            setAsSecondaryDriver: values.setAsSecondaryDriver ? true : false,
            isEvDriver: values.isEvDriver ? true : false
        };

        createDriverAdhoc(body)
            .then((result) => {
                if (files.length > 0) {
                    const data = new FormData();
                    data.append("id", result.data.id);
                    [...files].map((f) => {
                        data.append("files", f)
                    })
                    driverDocumentUpload(data).then((result) => {
                        setShowApiLoader(false);
                        showAlert("success", "Created Driver Successfully");
                        reset({
                            sapId: "",
                            isSapData: false,
                            fullName: "",
                            gender: "",
                            dob: "",
                            mobile: "",
                            addressLine: "",
                            city: "",
                            pincode: "",
                            state: "",
                            education: "",
                            experience: "",
                            langKnown: "",
                            licenseNo: "",
                            badge: "",
                            bangDriverId: "",
                            remarks: "",
                            fathersName: "",
                            phone1: "",
                            phone2: "",
                            licenseExpiry: "",
                            mainCabNoTypeDropdown: "",
                            driverRatingDropdown: "",
                            aggregatorDropdown: "",
                            serviceCity: "",
                            panCardNo: "",
                            aadharNo: "",
                            driverTypeDropdown: "",
                            isAvailable: true,
                            badgeExpiry: "",
                            displayCardNo: "",
                            displayCardNoExpiry: "",
                            policeVerificationCode: "",
                            vendor: "",
                            policeVerificationExpiry: "",
                            setAsPrimaryDriver: true,
                            setAsSecondaryDriver: false,
                            isEvDriver: false
                        })
                        setFiles([]);
                        setIsAdvanced(false)
                        setTabName("Driver Information")
                        setConfirmationModal(false)
                        LargeModaltoggle();
                    })
                        .catch((err) => {
                            setShowApiLoader(false);
                            showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
                        });

                } else {
                    setShowApiLoader(false);
                    showAlert("success", "Created Driver Successfully");
                    reset({
                        sapId: "",
                        isSapData: false,
                        fullName: "",
                        gender: "",
                        dob: "",
                        mobile: "",
                        addressLine: "",
                        city: "",
                        pincode: "",
                        state: "",
                        education: "",
                        experience: "",
                        langKnown: "",
                        licenseNo: "",
                        badge: "",
                        bangDriverId: "",
                        remarks: "",
                        fathersName: "",
                        phone1: "",
                        phone2: "",
                        licenseExpiry: "",
                        mainCabNoTypeDropdown: "",
                        driverRatingDropdown: "",
                        aggregatorDropdown: "",
                        serviceCity: "",
                        panCardNo: "",
                        aadharNo: "",
                        driverTypeDropdown: "",
                        isAvailable: true,
                        badgeExpiry: "",
                        displayCardNo: "",
                        displayCardNoExpiry: "",
                        policeVerificationCode: "",
                        vendor: "",
                        policeVerificationExpiry: "",
                        setAsPrimaryDriver: true,
                        setAsSecondaryDriver: false,
                        isEvDriver: false
                    })
                    setFiles([]);
                    setIsAdvanced(false)
                    setTabName("Driver Information")
                    setConfirmationModal(false)
                    LargeModaltoggle();
                }
            })
            .catch((err) => {
                setShowApiLoader(false);
                showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
            });
    }

    const onFormSubmit = () => {
        const formValues = getValues()
        console.log("form values", formValues);
        setShowApiLoader(true);
        if (editId) {
            const body = {
                id: editId,
                userId: driverDetails.userId ? driverDetails.userId : null,
                sapId: formValues.sapId ? formValues.sapId : null,
                isSapData: formValues.isSapData ? formValues.isSapData : null,
                fullName: formValues.fullName ? formValues.fullName : null,
                gender: formValues.gender ? formValues.gender : null,
                dob: formValues.dob ? new Date(formValues.dob) : null,
                mobile: formValues.mobile ? formValues.mobile : null,
                addressLine: formValues.addressLine ? formValues.addressLine : null,
                city: formValues.city ? formValues.city : null,
                pincode: formValues.pincode ? formValues.pincode : null,
                state: formValues.state ? formValues.state : null,
                education: formValues.education ? formValues.education : null,
                experience: formValues.experience ? formValues.experience : null,
                langKnown: formValues.langKnown ? formValues.langKnown : null,
                licenseNo: formValues.licenseNo ? formValues.licenseNo : null,
                badge: formValues.badge ? formValues.badge : null,
                remarks: formValues.remarks ? formValues.remarks : null,
                fathersName: formValues.fathersName ? formValues.fathersName : null,
                phone1: formValues.phone1 ? formValues.phone1 : null,
                phone2: formValues.phone2 ? formValues.phone2 : null,
                avatarUrl: driverDetails.avatarUrl ? driverDetails.avatarUrl : null,
                avatarUrlContentType: driverDetails.avatarUrlContentType ? driverDetails.avatarUrlContentType : null,
                avatarUrlData: driverDetails.avatarUrlData ? driverDetails.avatarUrlData : null,
                licenseExpiry: formValues.licenseExpiry ? new Date(formValues.licenseExpiry) : null,
                dailySubscriptionAmt: driverDetails.dailySubscriptionAmt ? driverDetails.dailySubscriptionAmt : null,
                mainCabNo: formValues.mainCabNoTypeDropdown?.carNo ? formValues.mainCabNoTypeDropdown.carNo : null,
                otherCabNo: formValues.mainCabNoTypeDropdown?.carNo ? formValues.mainCabNoTypeDropdown.carNo : null,
                ratingSum: driverDetails.ratingSum ? driverDetails.ratingSum : null,
                ratingCount: driverDetails.ratingCount ? driverDetails.ratingCount : 0,
                ratingAvg: driverDetails.ratingAvg ? driverDetails.ratingAvg : 0,
                createdOn: driverDetails.createdOn ? new Date(driverDetails.createdOn) : null,
                createdById: driverDetails.createdById ? driverDetails.createdById : null,
                isDeleted: driverDetails.isDeleted ? true : false,
                deletedOn: driverDetails.deletedOn ? new Date(driverDetails.deletedOn) : null,
                deletedById: driverDetails.deletedById ? driverDetails.deletedById : null,
                aggregatorId: formValues.aggregatorDropdown?.id ? formValues.aggregatorDropdown.id : null,
                serviceCityId: formValues.serviceCity?.id ? formValues.serviceCity.id : null,
                panCardNo: formValues.panCardNo ? formValues.panCardNo : null,
                aadharNo: formValues.aadharNo ? formValues.aadharNo : null,
                driverTypeId: formValues.driverTypeDropdown?.id ? formValues.driverTypeDropdown.id : null,
                isAvailable: formValues.isAvailable ? true : false,
                badgeExpiry: formValues.badgeExpiry ? new Date(formValues.badgeExpiry) : null,
                displayCardNo: formValues.displayCardNo ? formValues.displayCardNo : null,
                displayCardNoExpiry: formValues.displayCardNoExpiry ? new Date(formValues.displayCardNoExpiry) : null,
                policeVerificationDate: driverDetails.policeVerificationDate ? driverDetails.policeVerificationDate : null,
                vendor: formValues.vendor ? formValues.vendor : "",
                policeVerificationCode: formValues.policeVerificationCode ? formValues.policeVerificationCode : null,
                policeVerificationExpiry: formValues.policeVerificationExpiry ? new Date(formValues.policeVerificationExpiry) : null,
                megacabsRating: formValues.driverRatingDropdown ? formValues.driverRatingDropdown : null,
                bangDriverId: formValues.bangDriverId ? formValues.bangDriverId : null,
                isDriverAdhoc: false,
                setAsPrimaryDriver: formValues.setAsPrimaryDriver ? true : false,
                firebaseId: driverDetails.firebaseId ? driverDetails.firebaseId : null,
                setAsSecondaryDriver: formValues.setAsSecondaryDriver ? true : false,
                isEvDriver: formValues.isEvDriver ? true : false
            };

            updateDriverAdhoc(body)
                .then((result) => {
                    if (files.length > 0) {
                        const data = new FormData();
                        data.append("id", result.data.id);
                        [...files].map((f) => {
                            data.append("files", f)
                        })
                        driverDocumentUpload(data).then((result) => {
                            setShowApiLoader(false);
                            showAlert("success", "Updated Driver Successfully");
                            reset({
                                sapId: "",
                                isSapData: false,
                                fullName: "",
                                gender: "",
                                dob: "",
                                mobile: "",
                                addressLine: "",
                                city: "",
                                pincode: "",
                                state: "",
                                education: "",
                                experience: "",
                                langKnown: "",
                                licenseNo: "",
                                badge: "",
                                bangDriverId: "",
                                remarks: "",
                                fathersName: "",
                                phone1: "",
                                phone2: "",
                                licenseExpiry: "",
                                mainCabNoTypeDropdown: "",
                                driverRatingDropdown: "",
                                aggregatorDropdown: "",
                                serviceCity: "",
                                panCardNo: "",
                                aadharNo: "",
                                driverTypeDropdown: "",
                                isAvailable: true,
                                badgeExpiry: "",
                                displayCardNo: "",
                                displayCardNoExpiry: "",
                                policeVerificationCode: "",
                                vendor: "",
                                policeVerificationExpiry: "",
                                setAsPrimaryDriver: true,
                                setAsSecondaryDriver: false,
                                isEvDriver: false
                            })
                            setFiles([]);
                            setIsAdvanced(false)
                            setTabName("Driver Information")
                            setConfirmationModal(false)
                            LargeModaltoggle();
                        })
                            .catch((err) => {
                                setShowApiLoader(false);
                                showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
                            });

                    } else {
                        setShowApiLoader(false);
                        showAlert("success", "Updated Driver Successfully");
                        reset({
                            sapId: "",
                            isSapData: false,
                            fullName: "",
                            gender: "",
                            dob: "",
                            mobile: "",
                            addressLine: "",
                            city: "",
                            pincode: "",
                            state: "",
                            education: "",
                            experience: "",
                            langKnown: "",
                            licenseNo: "",
                            badge: "",
                            bangDriverId: "",
                            remarks: "",
                            fathersName: "",
                            phone1: "",
                            phone2: "",
                            licenseExpiry: "",
                            mainCabNoTypeDropdown: "",
                            driverRatingDropdown: "",
                            aggregatorDropdown: "",
                            serviceCity: "",
                            panCardNo: "",
                            aadharNo: "",
                            driverTypeDropdown: "",
                            isAvailable: true,
                            badgeExpiry: "",
                            displayCardNo: "",
                            displayCardNoExpiry: "",
                            policeVerificationCode: "",
                            vendor: "",
                            policeVerificationExpiry: "",
                            setAsPrimaryDriver: true,
                            setAsSecondaryDriver: false,
                            isEvDriver: false
                        })
                        setFiles([]);
                        setIsAdvanced(false)
                        setTabName("Driver Information")
                        setConfirmationModal(false)
                        LargeModaltoggle();
                    }
                })
                .catch((err) => {
                    setShowApiLoader(false);
                    showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
                });
        } else {
            const body = { login: formValues.mobile, email: `${formValues.mobile}@megacab.com`, authorities: ["ROLE_DRIVER"] }
            checkRoleAddition(body).then((result) => {
                if (result.data.message == "NotExist") {
                    createDriver();
                } else if (result.data.message == "AddRole") {
                    setShowApiLoader(false);
                    setConfirmationModal(true)
                }
            }).catch((err) => {
                setShowApiLoader(false);
                showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
            });
        }
    };
    const handleAggregatorSelect = (data) => {
        aggregatorField.onChange(data.value);
    };

    const handleCitySelectChange = (data) => {
        serviceCityField.onChange(data.value);
    };

    // const handleCarTypeSelectChange = (data) => {
    //     carTypeField.onChange(data.value);
    // };

    const handleDriverTypeSelectChange = (data) => {
        driverTypeField.onChange(data.value);
    };

    const searchCabData = async (inputValue) => {
        console.log("input value", inputValue)
        if (inputValue) {
            let data = cabData.filter((element) => {
                console.log(element.carNo.toLowerCase(), inputValue.toLowerCase())
                return element.carNo.toLowerCase().includes(inputValue.toLowerCase())
            }).map((element) => {
                return {
                    value: element,
                    label: element.carNo,
                };
            })
            return data;
        } else {
            let data = cabData.map((element) => {
                return {
                    value: element,
                    label: element.carNo,
                };
            })
            return data
        }
    };

    const getFile = () => {
        document.getElementById('upfile').click();
    };
    const onFileChange = event => {
        console.log("event files", event.target.files)
        setFiles([...files, ...event.target.files])
    };

    const deleteFile = (index) => {
        setFiles([...files].filter((f, i) => i != index))
    }

    console.log("files", files)

    const handlePrimaryDriverChange = () => {
        setValue("setAsPrimaryDriver", true)
        setValue("setAsSecondaryDriver", false)
    }

    const handleSecondaryDriverChange = () => {
        const values = getValues()
        if(driverDetails.isPrimary && values.setAsPrimaryDriver){
            setValue("setAsSecondaryDriver", true)
        }
        setValue("setAsPrimaryDriver", false)
    }

    return (
        <CommonModal
            isOpen={Large}
            title={title}
            toggler={() => {
                reset({
                    sapId: "",
                    isSapData: false,
                    fullName: "",
                    gender: "",
                    dob: "",
                    mobile: "",
                    addressLine: "",
                    city: "",
                    pincode: "",
                    state: "",
                    education: "",
                    experience: "",
                    langKnown: "",
                    licenseNo: "",
                    badge: "",
                    bangDriverId: "",
                    remarks: "",
                    fathersName: "",
                    phone1: "",
                    phone2: "",
                    licenseExpiry: "",
                    mainCabNoTypeDropdown: "",
                    driverRatingDropdown: "",
                    aggregatorDropdown: "",
                    serviceCity: "",
                    panCardNo: "",
                    driverTypeDropdown: "",
                    isAvailable: true,
                    badgeExpiry: "",
                    displayCardNo: "",
                    displayCardNoExpiry: "",
                    policeVerificationCode: "",
                    vendor: "",
                    policeVerificationExpiry: "",
                    setAsPrimaryDriver: true,
                    setAsSecondaryDriver: false,
                    isEvDriver: false
                })
                setFiles([]);
                setIsAdvanced(false)
                setTabName("Driver Information")
                LargeModaltoggle()
            }}
            size="xl"
        >
            <Form className="create-driver">
                {tabName == "Driver Information" ? <>
                    <Row>
                        <div style={{ fontSize: "18px", fontWeight: "500" }}>Driver Information</div>
                    </Row>
                    <Row>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Aggregator</Label>
                            <Col className="col-lg-12">
                                <CustomSelect
                                    className="driver-type-select"
                                    classNamePrefix="driver-type-select-options"
                                    isClearable={false}
                                    isSearchable={false}
                                    value={aggregatorList.find((element) => {
                                        return element.value?.id === aggregatorField?.value?.id;
                                    })}
                                    onChange={handleAggregatorSelect}
                                    placeholder="Select Aggregator"
                                    options={aggregatorList}
                                />
                                <span style={{ color: "red" }}>
                                    {errors?.aggregatorDropdown?.message}
                                </span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Service City</Label>
                            <Col lg="12">
                                <div className="city-select">
                                    <CustomSelect
                                        className="service-select"
                                        classNamePrefix="select"
                                        isClearable={false}
                                        isSearchable={false}
                                        value={cityData.find((element) => {
                                            return element?.value?.id === serviceCityField?.value?.id;
                                        })}
                                        isDisabled={editId ? true : false}
                                        onChange={handleCitySelectChange}
                                        placeholder="Select City"
                                        options={cityData}
                                    />
                                </div>
                                <span style={{ color: "red" }}>{errors?.serviceCity?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Full Name</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("fullName", {
                                        required: {
                                            value: true,
                                            message: "Driver Name is required",
                                        }, maxLength: {
                                            value: 50,
                                            message: "Full Name cannot exceed 50 characters",
                                        },
                                        pattern: {
                                            value: /^[A-Za-z\s]*$/,
                                            message: "Full Name can only contain letters and spaces",
                                        },
                                        onChange: (e) => {
                                            setValue("fullName", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>
                                    {errors?.fullName?.message}
                                </span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Gender</Label>
                            <Col lg="12">
                                <div className="city-select">
                                    <CustomSelect
                                        className="service-select"
                                        classNamePrefix="select"
                                        isClearable={false}
                                        isSearchable={false}
                                        value={genderData.find((element) => {
                                            return element?.value === genderField?.value;
                                        })}
                                        onChange={(data) => {
                                            genderField.onChange(data.value);
                                        }}
                                        placeholder="Select Gender"
                                        options={genderData}
                                    />
                                </div>
                                <span style={{ color: "red" }}>{errors?.gender?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Date Of Birth</Label>
                            <Col lg="12">
                                <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                    <DatePicker
                                        showIcon
                                        className="form-control datetimepicker-input digits"
                                        selected={DOBField.value}
                                        dropdownMode="select"
                                        showMonthDropdown
                                        showYearDropdown
                                        scrollableYearDropdown
                                        onChange={(date) => DOBField.onChange(date)}
                                        dateFormat="MMMM d yyyy"
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}
                                    />
                                </InputGroup>
                                <span style={{ color: "red" }}>
                                    {errors?.dob?.message}
                                </span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Mobile</Label>
                            <Col lg="12">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Driver Mobile"
                                    maxLength={10}
                                    value={driverMobileField.value}
                                    pattern="[0-9]+"
                                    onChange={(e) => {
                                        driverMobileField.onChange(e.target.value.replace(/[^0-9]/g, ''))
                                        console.log("value", e.target.value)
                                    }}
                                />
                                <span style={{ color: "red" }}>
                                    {errors?.mobile?.message}
                                </span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Address Line</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("addressLine", {
                                        required: {
                                            value: true,
                                            message: "Address Line is required",
                                        },
                                        onChange: (e) => {
                                            setValue("addressLine", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.addressLine?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">City</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("city", {
                                        required: {
                                            value: true,
                                            message: "City is required",
                                        },
                                        onChange: (e) => {
                                            setValue("city", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.city?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Pin Code</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("pincode", {
                                        onChange: (e) => {
                                            setValue("pincode", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.pincode?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">State</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("state", {
                                        onChange: (e) => {
                                            setValue("state", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.state?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Education</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("education", {
                                        onChange: (e) => {
                                            setValue("education", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.education?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Languages Known</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("langKnown", {
                                        onChange: (e) => {
                                            setValue("langKnown", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.langKnown?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Pan Card</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("panCardNo", {
                                        required: {
                                            value: true,
                                            message: "Pan Card is required",
                                        },
                                        onChange: (e) => {
                                            setValue("panCardNo", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.panCardNo?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Aadhaar Number</Label>
                            <Col lg="12">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Aadhaar Number"
                                    maxLength={12}
                                    value={driverAadhaarField.value}
                                    pattern="[0-9]+"
                                    onChange={(e) => {
                                        driverAadhaarField.onChange(e.target.value.replace(/[^0-9]/g, ''))
                                        console.log("value", e.target.value)
                                    }}
                                />
                                <span style={{ color: "red" }}>
                                    {errors?.aadharNo?.message}
                                </span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Driving License No</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("licenseNo", {
                                        required: {
                                            value: true,
                                            message: "Driving License No is required",
                                        },
                                        onChange: (e) => {
                                            setValue("licenseNo", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.licenseNo?.message}</span>
                            </Col>
                        </FormGroup>
                        
                       {editId?"":<FormGroup className="col-lg-3" style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                                <Input id="isAvailable" type="checkbox" checked={isAvailableField.value}
                                    onChange={(value) => isAvailableField.onChange(value)} />
                                <Label className="mb-0" for="isAvailable">Is Available</Label>
                            </div>
                        </FormGroup>} 
                        
                        <FormGroup className="col-lg-3" style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                                <Input id="isEVDriver" type="checkbox" checked={isEVDriverField.value}
                                    onChange={(value) => isEVDriverField.onChange(value)} />
                                <Label className="mb-0" for="isEVDriver">Is EV Driver</Label>
                            </div>
                        </FormGroup>
                    </Row>
                    <Row>
                        <div style={{ color: "#11BF5C", textDecoration: "underline", display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setIsAdvanced(!isAdvanced)}>Advanced Configurations {isAdvanced ? <ArrowUp style={{ width: "15px", height: "15px", marginLeft: "5px" }} /> : <ArrowDown style={{ width: "15px", height: "15px", marginLeft: "5px" }} />}</div>
                    </Row>
                    {isAdvanced ? <Row>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Sap Id</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("sapId", {
                                        onChange: (e) => {
                                            setValue("sapId", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3" style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                                <Input id="isSapData" type="checkbox" checked={isSapDataField.value}
                                    onChange={(value) => isSapDataField.onChange(value)} />
                                <Label className="mb-0" for="isSapData">Is Sap Data</Label>
                            </div>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Fathers Name</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("fathersName", {
                                        onChange: (e) => {
                                            setValue("fathersName", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.fathersName?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Phone 1</Label>
                            <Col lg="12">
                                <input
                                    type="text"
                                    className="form-control"
                                    // placeholder="Driver Mobile"
                                    maxLength={10}
                                    value={phone1Field.value}
                                    pattern="[0-9]+"
                                    onChange={(e) => {
                                        phone1Field.onChange(e.target.value.replace(/[^0-9]/g, ''))
                                    }}
                                />
                                <span style={{ color: "red" }}>{errors?.phone1?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Phone 2</Label>
                            <Col lg="12">
                                <input
                                    type="text"
                                    className="form-control"
                                    // placeholder="Driver Mobile"
                                    maxLength={10}
                                    value={phone2Field.value}
                                    pattern="[0-9]+"
                                    onChange={(e) => {
                                        phone2Field.onChange(e.target.value.replace(/[^0-9]/g, ''))
                                    }}
                                />
                                <span style={{ color: "red" }}>{errors?.phone2?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Experience</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("experience", {
                                        onChange: (e) => {
                                            setValue("experience", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.experience?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Bengaluru Driver ID</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("bangDriverId", {
                                        onChange: (e) => {
                                            setValue("bangDriverId", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.bangDriverId?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Remarks</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("remarks", {
                                        onChange: (e) => {
                                            setValue("remarks", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.remarks?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Vendor</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("vendor", {
                                        onChange: (e) => {
                                            setValue("vendor", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.vendor?.message}</span>
                            </Col>
                        </FormGroup>
                    </Row> : null}
                    <Row className="submit-driver">
                        <button className="btn btn-primary" type="button" onClick={async () => {
                            const result = await trigger(["aggregatorDropdown", "serviceCity", "fullName", "gender", "dob", "mobile", "addressLine", "city", "panCardNo", "aadharNo", "licenseNo"]);
                            if (result) {
                                setTabName("Cab Mapping");
                                setIsAdvanced(false)
                                clearErrors()
                            }
                        }}>
                            Next
                        </button>
                    </Row>
                </> : tabName == "Cab Mapping" ? <>
                    <Row>
                        <div style={{ fontSize: "18px", fontWeight: "500" }}>Cab Mapping</div>
                    </Row>
                    <Row>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Driver Rating By MegaCabs</Label>
                            <Col lg="12">
                                <div className="city-select">
                                    <CustomSelect
                                        className="service-select"
                                        classNamePrefix="select"
                                        isClearable={false}
                                        isSearchable={false}
                                        value={ratingData.find((element) => {
                                            return element?.value === driverRatingField?.value;
                                        })}
                                        onChange={(data) => driverRatingField.onChange(data.value)}
                                        placeholder={
                                            "Select Rating"
                                        }
                                        options={ratingData}
                                    />
                                </div>
                                <span style={{ color: "red" }}>
                                    {errors?.driverRatingDropdown?.message}
                                </span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Main Cab No</Label>
                            <Col lg="12">
                                <div className="city-select">
                                    <CustomAutoSuggest
                                        id={"Main Cab No"}
                                        registerName={"mainCabNo"}
                                        handleSelectChange={(data) => {
                                            setValue("mainCabNo", data.value.carNo)
                                            mainCabNoField.onChange(data.value)
                                        }}
                                        options={searchCabData}
                                        placeholder={serviceCityField?.value?.id ? "Select Main Cab No" : "Select service city to select cab no"}
                                        register={register}
                                        inputType={"text"}
                                        inputProps={{
                                            required: {
                                                value: true,
                                                message: "Main Cab No is required",
                                            },
                                            disabled: serviceCityField?.value?.id ? false : true
                                        }}
                                        dependentRegisterName={""}
                                        isInitialLoadData={true}
                                    />
                                </div>
                                <span style={{ color: "red" }}>
                                    {errors?.mainCabNo?.message}
                                </span>
                            </Col>
                        </FormGroup>
                        {/* <FormGroup className="col-lg-4">
              <Label className="col-lg-12 col-form-label">Cab Type</Label>
              <Col lg="12">
                <div className="city-select">
                  <Select
                    className="service-select"
                    classNamePrefix="select"
                    isClearable={false}
                    isSearchable={false}
                    value={carTypeData.find((element) => {
                      return element?.value?.id === carTypeField?.value?.id;
                    })}
                    isDisabled={serviceCityField?.value?.id ? false : true}
                    onChange={handleCarTypeSelectChange}
                    placeholder={
                      serviceCityField?.value?.id
                        ? "Select Car Type"
                        : "Select city to select car type"
                    }
                    options={carTypeData}
                  />
                </div>
                <span style={{ color: "red" }}>
                  {errors?.carTypeDropdown?.message}
                </span>
              </Col>
            </FormGroup> */}

                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Driver Type</Label>
                            <Col className="col-lg-12">
                                <CustomSelect
                                    className="driver-type-select"
                                    classNamePrefix="driver-type-select-options"
                                    isClearable={false}
                                    isSearchable={false}
                                    defaultValue={driverTypeList.find((element) => {
                                        return element.value?.id === driverTypeField?.value?.id;
                                    })}
                                    onChange={handleDriverTypeSelectChange}
                                    placeholder="Select Driver Type"
                                    options={driverTypeList}
                                />
                            </Col>
                            <span style={{ color: "red" }}>
                                {errors?.driverTypeDropdown?.message}
                            </span>
                        </FormGroup>
                        <FormGroup className="col-lg-4" style={{ display: "flex", alignItems: "center" }}>
                            <div className="m-checkbox-inline mb-0 custom-radio-ml" style={{ display: "flex", alignItems: "center" }}>
                                <div className="radio radio-primary">
                                    <Input id="radioinline2" type="radio" name="isPrimary" checked={isPrimaryDriverField.value} onChange={handlePrimaryDriverChange} />
                                    <Label className="mb-0" for="radioinline2">{"Is Primary Driver"}</Label>
                                </div>
                                <div className="radio radio-primary">
                                    <Input id="radioinline3" type="radio" name="isSecondary" checked={!isPrimaryDriverField.value} onChange={handleSecondaryDriverChange} />
                                    <Label className="mb-0" for="radioinline3">{"Is Secondary Driver"}</Label>
                                </div>
                            </div>
                        </FormGroup>
                    </Row>
                    {/* <Row>
            <div style={{ color: "#11BF5C", textDecoration: "underline", display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setIsAdvanced(!isAdvanced)}>Advanced Configurations {isAdvanced ? <ArrowUp style={{ width: "15px", height: "15px", marginLeft: "5px" }} /> : <ArrowDown style={{ width: "15px", height: "15px", marginLeft: "5px" }} />}</div>
          </Row>
          {isAdvanced ? <Row>
            
          </Row> : null} */}


                    <Row className="submit-driver">
                        <button className="btn btn-primary" type="button"
                            onClick={async () => {
                                setTabName("Driver Information");
                                setIsAdvanced(false)
                                clearErrors()
                            }}>
                            Back
                        </button>
                        <button className="btn btn-primary" style={{ marginLeft: "20px" }} type="button" onClick={async () => {
                            const result = await trigger(["mainCabNo","mainCabNoTypeDropdown", "driverTypeDropdown"]);
                            if (result) {
                                setTabName("Alert Settings");
                                setIsAdvanced(false)
                                clearErrors()
                            }
                        }} >
                            Next
                        </button>
                    </Row>
                </> : tabName == "Alert Settings" ? <>
                    <Row>
                        <div style={{ fontSize: "18px", fontWeight: "500" }}>Alert Settings</div>
                    </Row>
                    <Row>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Driving License No Expiry Date</Label>
                            <Col lg="12">
                                <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                    <DatePicker
                                        showIcon
                                        className="form-control datetimepicker-input digits"
                                        selected={DrivingLicenseExpiryField.value}
                                        dropdownMode="select"
                                        showMonthDropdown
                                        showYearDropdown
                                        scrollableYearDropdown
                                        onChange={(date) => DrivingLicenseExpiryField.onChange(date)}
                                        dateFormat="MMMM d yyyy"
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}
                                    />
                                </InputGroup>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Badge No</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("badge", {
                                        onChange: (e) => {
                                            setValue("badge", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.badge?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Badge No Expiry Date</Label>
                            <Col lg="12">
                                <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                    <DatePicker
                                        showIcon
                                        className="form-control datetimepicker-input digits"
                                        selected={badgeExpiryField.value}
                                        dropdownMode="select"
                                        showMonthDropdown
                                        showYearDropdown
                                        scrollableYearDropdown
                                        onChange={(date) => badgeExpiryField.onChange(date)}
                                        dateFormat="MMMM d yyyy"
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}
                                    />
                                </InputGroup>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Display Card No</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("displayCardNo", {
                                        onChange: (e) => {
                                            setValue("displayCardNo", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.displayCardNo?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Display Card No Expiry Date</Label>
                            <Col lg="12">
                                <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                    <DatePicker
                                        showIcon
                                        className="form-control datetimepicker-input digits"
                                        selected={displayCardNoExpiryField.value}
                                        dropdownMode="select"
                                        showMonthDropdown
                                        showYearDropdown
                                        scrollableYearDropdown
                                        onChange={(date) => displayCardNoExpiryField.onChange(date)}
                                        dateFormat="MMMM d yyyy"
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}
                                    />
                                </InputGroup>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Police Verification Code</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("policeVerificationCode", {
                                        onChange: (e) => {
                                            setValue("policeVerificationCode", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.policeVerificationCode?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Police Verification Date</Label>
                            <Col lg="12">
                                <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                    <DatePicker
                                        showIcon
                                        className="form-control datetimepicker-input digits"
                                        selected={policeVerificationExpiryField.value}
                                        dropdownMode="select"
                                        showMonthDropdown
                                        showYearDropdown
                                        scrollableYearDropdown
                                        onChange={(date) => policeVerificationExpiryField.onChange(date)}
                                        dateFormat="MMMM d yyyy"
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}
                                    />
                                </InputGroup>
                            </Col>
                        </FormGroup>
                    </Row>
                    {/* <Row>
            <div style={{ color: "#11BF5C", textDecoration: "underline", display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setIsAdvanced(!isAdvanced)}>Advanced Configurations {isAdvanced ? <ArrowUp style={{ width: "15px", height: "15px", marginLeft: "5px" }} /> : <ArrowDown style={{ width: "15px", height: "15px", marginLeft: "5px" }} />}</div>
          </Row>
          {isAdvanced ? <Row>
            
          </Row> : null} */}


                    <Row className="submit-driver">
                        <button className="btn btn-primary" type="button" onClick={() => {
                            setTabName("Cab Mapping");
                            setIsAdvanced(false)
                            clearErrors()
                        }}>
                            Back
                        </button>
                        <button className="btn btn-primary" style={{ marginLeft: "20px" }} type="button"
                            onClick={async () => {
                                const result = await trigger([]);
                                if (result) {
                                    setTabName("Document Upload");
                                    setIsAdvanced(false)
                                    clearErrors()
                                }
                            }}>
                            Next
                        </button>
                    </Row>
                </> : <>
                    <Row>
                        <div style={{ fontSize: "18px", fontWeight: "500" }}>Document Upload</div>
                    </Row>
                    <Row>
                        <div>Please upload the required documents</div>
                        <div className="d-inline-flex" style={{ margin: "20px 0px" }}>
                            <div className="btn btn-primary" style={{ display: "flex", alignItems: "center", justifyContent: "center" }} onClick={getFile}><PlusSquare style={{ marginRight: "10px" }} />AddNew</div>
                            <div style={{ height: '0px', width: '0px', overflow: 'hidden' }}>
                                <Input id="upfile" multiple type="file" onChange={(e) => onFileChange(e)} /></div>
                        </div>
                        <Table style={{ marginBottom: "20px" }} dark={mix_background_layout == "dark-only" ? true : false} >
                            <thead><tr></tr></thead>
                            <tbody>
                                {files && files.length ?
                                    [...files].map((file, i) => {
                                        return (
                                            <tr key={i} >
                                                <td></td>
                                                <td style={{color: mix_background_layout == "dark-only" ? "white" : null}}>
                                                    <H6 attrH6={{ className: 'task_title_0' }} >{file.name}</H6>
                                                </td>
                                                <td><a href="#javascript" onClick={() => deleteFile(i)}><Trash2 /></a></td>
                                                <td></td>
                                            </tr>
                                        );
                                    })
                                    : uploadedFiles.length == 0 ? <tr><td style={{color: mix_background_layout == "dark-only" ? "white" : null}}><div className="no-favourite"><span>{"No Files Uploaded"}</span></div></td></tr>
                                        : null
                                }
                                {uploadedFiles && uploadedFiles.length ?
                                    [...uploadedFiles].map((file, i) => {
                                        return (
                                            <tr key={i} >
                                                <td></td>
                                                <td style={{color: mix_background_layout == "dark-only" ? "white" : null}}>
                                                    <H6 attrH6={{ className: 'task_title_0' }} >{file.fileName}</H6>
                                                </td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        );
                                    })
                                    : null
                                }
                            </tbody>

                        </Table>
                    </Row>
                    <Row className="submit-driver">
                        <button className="btn btn-primary" type="button" onClick={() => {
                            setTabName("Alert Settings");
                            setIsAdvanced(false)
                            clearErrors()
                        }}>
                            Back
                        </button>
                        <button className="btn btn-primary" style={{ marginLeft: "20px" }} type="button" onClick={onFormSubmit} >
                            {editId ? "Update" : "Create"}
                        </button>
                    </Row></>}
            </Form>
            <CommonModal
                isOpen={confirmationModal}
                title={"Confirmation"}
                toggler={() => setConfirmationModal(!confirmationModal)}
                size="md"
            >
                <Row className="driver-push-notification">
                    <Col xl="12" className="push-botification-body">
                        <div className="text-center">User already added, do you want to add as a Driver ?</div>
                    </Col>
                    <Col xl="12" className="push-notification-footer">
                        <button
                            className="btn btn-primary"
                            onClick={() => createDriver()}
                        >
                            Confirm
                        </button>
                    </Col>
                </Row>
            </CommonModal>
        </CommonModal>
    );
};

export default CreateDriver;
